<div [attr.aria-live]="getAriaLive()" class="visually-hidden"  >{{announcement$ | async}}</div>
